import { useApi } from "shared/services/api/useApi";
import { useQuery } from "react-query";

export const usePageAccess = (pageRoute, userId, currentDepartmentId) => {
    const { getDataAsync } = useApi();

    const { data: authorized = null, isFetched } = useQuery(
        ["pageAuthorization", pageRoute, userId, currentDepartmentId],
        async () => {
            const payload = await getDataAsync("pageAuthorization", {
                params: {
                    pageRoute,
                    userId,
                    departmentId: currentDepartmentId,
                },
            });
            return payload.json();
        },
        {
            enabled: !!pageRoute,
            staleTime: 8 * 60 * 60 * 1000,
            cacheTime: 8 * 60 * 60 * 1000,
        }
    );

    return { authorized, isFetched };
};
